// Quill 2's getSemanticHTML() serializes every space as &nbsp; (text can then
// only wrap mid-word) and blank lines as bare <p></p> (which collapse to zero
// height outside the editor). Undo both before rendering stored quill HTML.
export function normalizeQuillHtml(html: string): string {
  if (!html) {
    return html;
  }
  return html
    .replace(/&nbsp;/g, ' ')
    .replace(/<p(\s[^>]*)?><\/p>/gi, (_, attrs) => `<p${attrs || ''}><br></p>`);
}

// Drop-in [valueGetter] for <quill-editor> so the normalized HTML is what
// gets saved. Mirrors ngx-quill's default valueGetter contract: an empty
// editor maps to null (its defaultEmptyValue).
const EMPTY_EDITOR_HTML = ['<p></p>', '<div></div>', '<p><br></p>', '<div><br></div>'];

export function quillHtmlValueGetter(quillEditor: any): string {
  const html = quillEditor.getSemanticHTML();
  if (EMPTY_EDITOR_HTML.includes(html)) {
    return null;
  }
  return normalizeQuillHtml(html);
}
